/* unplugin-vue-components disabled */import script from "./Footer.vue?vue&type=script&setup=true&lang=ts"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts"

import "./Footer.vue?vue&type=style&index=0&id=6a9dbed8&scoped=true&lang=less"

import exportComponent from "/Users/crossle/Code/github.com/OneMornin/mornin.one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a9dbed8"]])

export default __exports__